<template>

    <modal-container>

        <!-- Top navbar -->
        <modal-header
            :title="'Home Credit product loan'"
            :right="'close-dark'"
            :noIcon="true">
        </modal-header>

        <template>

            <!-- Loading animation -->
            <lottie class="loading-animation" :options="{animationData: $root.loadAnimation}" v-if="initLoad"/>

            <!-- Prompt content -->
            <prompt-div v-if="!initLoad">

                <!-- Layout body -->
                <template v-slot:body>

                    <div class="d-flex flex-column justify-content-center" style="height: 15rem;">
                        <img src="/images/illustration-happy-shopper.svg" alt="" />

                        <!-- Merchant image icon -->
                        <div class="d-flex bg-white rounded-circle mx-auto mt-n4" style="width: 4rem; height: 4rem;" v-if="fromMerchant">
                            <img class="img img-fluid my-auto" :src="'/image/' + currMerchant.imageId" @error="$root.imageAlt" alt="" />
                        </div>
                    </div>

                    <div>
                        <h3 class="font-lg font-weight-bolder" v-text="headingFinal"></h3>
                        <h4 class="font-md mt-4 mx-n4" v-text="textFinal"></h4>
                        <div class="d-flex justify-content-center mt-4 mx-n6">
                            <div class="text-left">
                                <list-icon v-for="(text, key) in bulletsFinal" :key="key">
                                    <template v-slot:icon>
                                        <img src="/images/icon-circle-tick.svg" alt="">
                                    </template>
                                    <template v-slot:description>{{ text }}</template>
                                </list-icon>
                            </div>
                        </div>
                    </div>

                    <!-- Bottom Bar -->
                    <div class="bottom-bar-buffer"></div>
                    <div class="bottom-bar fixed-bottom full-width text-center p-4">
                        <ga-click
                            componentIsA="button"
                            class="btn btn-primary btn-block"
                            ga-category="Button Click"
                            ga-label="Generic POS Apply Button"
                            v-html="'Get pre-approved in 2 minutes'"
                            :disabled="applyButtonDisabled || !$store.state.session.canGenPos"
                            @componentClicked="applyPos()">
                        </ga-click>
                    </div>

                </template>

            </prompt-div>

        </template>

    </modal-container>

</template>

<script>
    export default {
        props: {
            params: {
                default: null,
            }
        },

        data: function() {
            return {
                initLoad: false,
                applyButtonDisabled: false,
                currMerchant: {},
                fromMerchant: false,
                heading: "Shop on installments in any of our 10,000+ partner stores",
                headingWithMerchant: "Shop on installments in any of :merchant stores nationwide",
                text: "If you choose this option, we will not place an order to a specific store. Instead, you can shop anything and anywhere with us.",
                textWithMerchant: ":merchant cannot reserve this item for you, but you can still apply for a product loan and visit their stor to shop with us.",
                bulletPoints: [
                    'Apply & get result in 2 minutes',
                    'Visit any of our partner stores nationwide',
                    'Buy anything you love on installment',
                ],
                bulletPointsWithMerchant: [
                    'Apply & get result in 2 minutes',
                    'Visit any of :merchant stores',
                    'Check item availability & shop',
                ]
            }
        },

        computed: {
            textFinal() {
                return this.params.merchant ? _.replace(this.textWithMerchant, ':merchant', this.params.merchant.name) : this.text
            },
            headingFinal() {
                return this.params.merchant ? _.replace(this.headingWithMerchant, ':merchant', this.params.merchant.name) : this.heading
            },
            bulletsFinal() {
                if(this.params.merchant) {
                    let merchantName = this.params.merchant.name
                    return _.map(this.bulletPointsWithMerchant, function(value) {
                        return _.replace(value, ':merchant', merchantName)
                    })
                } else {
                    return this.bulletPoints
                }
            }
        },

        created: function () {
            if(this.params.merchant) {
                this.fromMerchant = true
                this.currMerchant = this.params.merchant
            } else {
                this.currMerchant = this.params.product.merchant
            }
        },

        methods: {
            getCheckoutSource() {
                return _.get(this.params, 'checkout_source', 'product_detail_alt_banner');
            },
            applyPos() {
                this.$root.recordAndroidAnalytics('mpl_genpos_entry', {}, ['appsflyer'])
                this.$root.recordAndroidAnalytics('MPL GenPos Crossover', {}, ['moengage'])
                this.$root.recordAndroidAnalytics('mpl_genpos_crossover', {}, ['appsflyer'])

                if(!this.$store.state.session.genPosCompatible) {
                    this.$root.openModal('modal_situation', {
                        shortText: 'Your installment shopping is just one update away...',
                        longText: 'We are inviting you to shop with us! We just need you to update your app to the latest version so you can enjoy shopping in our Marketplace.'
                    })
                } else if(this.$store.state.session.canGenPos && !this.applyButtonDisabled) {
                    this.initLoad = true
                    this.applyButtonDisabled = true

                    let offer = _.head(this.params.product.offers[this.currMerchant.id])
                    axios
                        .post("/genposTransactions/generic/apply", {
                            'product_id': this.params.product.id,
                            'checkout_source': this.getCheckoutSource()
                        })
                        .then(response => {
                            if(response.data.transactionId) {
                                // if mobile
                                window.location.replace("exit?location=mpos")
                            }
                        })
                }
            }
        }
    }
</script>
